import styled from "styled-components";

const bp = { md: "900px" };

const c = {
  ink: "#2a1f1f",
  soft: "rgba(42,31,31,0.75)",
  gold: "#c9a227",
  page: "#ffffff",
};

export const Wrap = styled.section`
  width: 100%;
  padding: 50px 0;
  position: relative;
  isolation: isolate;
  background: #fff;

  /* ✅ LINE-ART elegant (contur) */
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;

    /* SVG în două straturi: roz + auriu */
    background-image:
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1400' height='900' viewBox='0 0 1400 900'%3E%3Cg fill='none' stroke='%23fc9ac4' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' opacity='0.22'%3E%3Cpath d='M220 560c120-220 380-320 630-250 120 34 220 120 260 230 50 140-20 300-160 360-120 52-260 20-340-70-70-80-75-190-30-280 60-120 210-165 320-120 80 34 125 110 110 190-18 98-120 150-205 120-74-26-110-105-78-172 28-60 112-76 160-40 44 34 48 102 0 135-44 30-100 6-110-40'/%3E%3Cpath d='M980 220c-40 40-55 92-30 140 26 50 92 70 145 42 64-34 76-118 18-160-50-38-120-18-140 40-20 56 28 112 88 100'/%3E%3Cpath d='M1080 650c70 20 140 10 200-34'/%3E%3Cpath d='M150 300c60-30 130-25 190 14'/%3E%3C/g%3E%3C/svg%3E"),
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1400' height='900' viewBox='0 0 1400 900'%3E%3Cg fill='none' stroke='%23c9a227' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' opacity='0.18'%3E%3Cpath d='M250 590c130-230 410-330 680-250 130 38 240 130 280 250 52 155-26 325-178 385-130 52-280 12-365-88-78-90-80-212-25-315 70-130 240-175 365-120 92 40 144 130 120 225-28 110-148 165-245 125-90-36-128-130-90-210 35-70 135-90 195-45 52 42 55 120-2 160-50 36-120 10-132-48'/%3E%3Cpath d='M1015 245c-50 45-64 108-34 160 30 54 108 78 172 45 78-40 92-140 22-190-60-42-140-15-162 55-24 64 32 130 102 112'/%3E%3C/g%3E%3C/svg%3E");

    background-repeat: no-repeat, no-repeat;

    /* poziționare “ca în exemplul tău”: mare, ușor în stânga, plus accent în dreapta */
    background-position:
      left -220px top 120px,
      right -260px top 80px;

    /* mărime mare, să fie “aerisit” */
    background-size:
      1100px auto,
      980px auto;

    opacity: 1;
  }
`;

export const Inner = styled.div`
  width: min(900px, calc(100% - 40px));
  margin: 0 auto;
  text-align: center;
  display: grid;
  gap: 2px;

  position: relative;
  z-index: 1; /* ✅ peste desen */
`;
export const Title = styled.h2`
  margin: 0;
  font-family: "Cormorant Garamond", serif;
  font-size: 58px;
  font-weight: 500;
  letter-spacing: 0.02em;
  color: ${c.ink};

  @media (max-width: ${bp.md}) {
    font-size: 38px;
  }
`;

export const Script = styled.div`
  font-family: "Ephesis", cursive;
  font-size: 30px;
  color: ${c.soft};
  @media (max-width: ${bp.md}) {
    font-size: 24px;
  }
`;

export const PortraitWrap = styled.div`
  display: grid;
  place-items: center;
  margin-top: 6px;
`;

/* Medalion: cerc cu inel fin + micro highlight */
export const PortraitFrame = styled.div`
  width: min(500px, 92vw); /* 🔥 mai mare */
  display: grid;
  place-items: center;
`;

export const PortraitImg = styled.img`
  width: 100%;
  height: auto;
  display: block;

  /* IMPORTANT: dacă PNG-ul are transparență și ramă rotundă,
     nu mai aplicăm border-radius sau crop. */

  /* opțional: umbră foarte fină, premium */
  filter: drop-shadow(0 12px 26px rgba(0, 0, 0, 0.16));
`;

export const GoldLine = styled.div`
  width: 70px;
  height: 1px;
  background: ${c.gold};
  margin: 16px auto 10px;
`;

export const Text = styled.p`
  margin: 0 auto;
  font-size: 20px;
  line-height: 1.9;
  color: ${c.soft};
  max-width: 72ch;
  font-family: "Cormorant Garamond", serif;

  @media (max-width: ${bp.md}) {
    line-height: 1.4;
  }
`;

export const Actions = styled.div`
  margin-top: 20px;
`;

export const PrimaryBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;

  font-family: "Cormorant Garamond", serif;
  font-size: 18px;
  letter-spacing: 0.08em;
  color: ${c.gold};

  position: relative;
  padding: 6px 0;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -4px;
    height: 1px;
    background: ${c.gold};
  }
`;
